import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { URL_PDF } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class PdfService {
  constructor(private http: HttpClient) {}

  generatePdf(header: HTMLElement, footer: HTMLElement, body: HTMLElement) {
    let _header = header.outerHTML;
    let _footer = footer.innerHTML;
    let _body = body.outerHTML;

    return this.http
      .post(
        URL_PDF,
        { header: _header, footer: _footer, body: _body },
        { responseType: "blob" }
      )
      .pipe(
        map((res: any) => {
          console.log(res);
          return res;
          // return new Blob([res], { type: "application/pdf" });
        })
        // catchError((err) => {
        //   return throwError(err);
        // })
      );
  }
}
